/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { ITelemetryItem } from '@microsoft/applicationinsights-core-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
    ApplicationInsights,
    SeverityLevel,
} from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';
import Cookies from 'js-cookie';

import getEnvironment from '../util/EnvironmentUtil';

const emailPiiRegex = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+/g;
const emailPiiMask = '<PII_EMAIL>';

function loadInstrumentationKeyFromEnv() {
    const environment = getEnvironment();
    if (environment === 'local') {
        return require('../envConfigs/local.json')['APPLICATION_INSIGHTS_INSTRUMENTATION_KEY'];
    } else if (environment === 'nst') {
        return require('../envConfigs/nst.json')['APPLICATION_INSIGHTS_INSTRUMENTATION_KEY'];
    } else if (environment === 'alp') {
        return require('../envConfigs/alp.json')['APPLICATION_INSIGHTS_INSTRUMENTATION_KEY'];
    } else if (environment === 'stg') {
        return require('../envConfigs/stg.json')['APPLICATION_INSIGHTS_INSTRUMENTATION_KEY'];
    }
    return require('../envConfigs/prd.json')['APPLICATION_INSIGHTS_INSTRUMENTATION_KEY'];
}
const instrumentationKey = loadInstrumentationKeyFromEnv();
const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: instrumentationKey,
        extensions: [ reactPlugin ],
        enableAutoRouteTracking: true,
        extensionConfig: { [reactPlugin.identifier]: { history: browserHistory } },
    },
});
appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((item: ITelemetryItem) => {
    try {
        item.tags = item.tags ?? [];
        item.tags['ai.cloud.role'] = 'auth0';
    } catch (e) {
        console.error(e);
        return false;
    }
});

appInsights.addTelemetryInitializer((item: ITelemetryItem) => {
    try {
        const itemJson = JSON.stringify(item);
        const isEmailPiiFound = itemJson.search(emailPiiRegex) > -1;
        if (isEmailPiiFound) {
            const sanitizedItemString = itemJson.replace(emailPiiRegex, emailPiiMask);
            const itemObj = JSON.parse(sanitizedItemString);
            Object.assign(item, itemObj);
        }
    } catch (e) {
        console.error(e);
        return false;
    }
});

appInsights.context.application = {
    build: getEnvironment(),
    ver: getEnvironment(),
};

export function logClick(from: string, internal: boolean, link: string) {
    const _ga = Cookies.get('_ga');
    appInsights.trackTrace(
        {
            message: 'Click',
            severityLevel: SeverityLevel.Information,
        },
        {
            _ga,
            from,
            internal,
            link,
        },
    );
}

export function logSignupSubmit(subscriptionPlan: string | null) {
    const _ga = Cookies.get('_ga');
    const signupType = 'basic';
    appInsights.trackTrace(
        {
            message: 'Signup Submit',
            severityLevel: SeverityLevel.Information,
        },
        {
            _ga,
            subscriptionPlan,
            signupType,
        },
    );
}

export default appInsights;
